const COPY_BUTTON_SELECTOR = '[data-livestream-copy-button]';
const COPY_SOURCE_SELECTOR = '[data-livestream-copy-source]';
const COPY_FIELD_SELECTOR = '.b-livestream-instructions-events__copy-field';
const BLOCK_SELECTOR = '.b-livestream-instructions-events';
const STATUS_SELECTOR = '.b-livestream-instructions-events__copy-status';
const buttonResetTimers = new WeakMap();

function fallbackCopy(value) {
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    return document.execCommand('copy');
  } finally {
    textarea.remove();
  }
}

async function copyText(value) {
  if (window.isSecureContext && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      return fallbackCopy(value);
    }
  }

  return fallbackCopy(value);
}

function announce(button, message) {
  const status = button.closest(BLOCK_SELECTOR)?.querySelector(STATUS_SELECTOR);

  if (status) {
    status.textContent = '';
    requestAnimationFrame(() => {
      status.textContent = message;
    });
  }
}

function showCopied(button) {
  const existingTimer = buttonResetTimers.get(button);

  if (existingTimer) {
    window.clearTimeout(existingTimer);
  }

  button.textContent = 'Copied';
  buttonResetTimers.set(
    button,
    window.setTimeout(() => {
      button.textContent = 'Copy';
      buttonResetTimers.delete(button);
    }, 2000)
  );
}

async function handleCopy(button) {
  const source = button.closest(COPY_FIELD_SELECTOR)?.querySelector(COPY_SOURCE_SELECTOR);
  const value = source?.textContent?.trim() || '';
  const field = button.dataset.copyField || 'Value';

  if (!value) {
    announce(button, `${field} is not available to copy.`);
    return;
  }

  try {
    const copied = await copyText(value);

    if (!copied) {
      throw new Error('Copy command failed');
    }

    showCopied(button);
    announce(button, `${field} copied to clipboard.`);
  } catch {
    announce(button, `Copy failed. Select and copy ${field} manually.`);
  } finally {
    button.focus({ preventScroll: true });
  }
}

document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest(COPY_BUTTON_SELECTOR);

  if (!(button instanceof HTMLButtonElement)) return;

  void handleCopy(button);
});
